window.okeReviewsWidgetOnInit = function () {
    var selector = '.m-reviews-section';
    if(!document.querySelector(selector)) {
      var selector = '.b-reviews-section';  
    }
  
    // custom feature: on clicking the first widget's show more button, scroll to second widget
    let showMoreButtonInTab = document.querySelector('#collapse-tab-okendo .okeReviews .okeReviews-reviews-showMore');
  
  	const bottomWidgetHolder = document.querySelector(selector+'#reviews');
    if (showMoreButtonInTab && bottomWidgetHolder) {
        const showMoreCollapseOld = showMoreButtonInTab;
        showMoreButtonInTab = showMoreCollapseOld.cloneNode(true);
        showMoreCollapseOld.parentNode.replaceChild(showMoreButtonInTab, showMoreCollapseOld);
        showMoreButtonInTab.addEventListener('click', function (e) {
            e.preventDefault();
            bottomWidgetHolder.scrollIntoView({
                behavior: 'smooth'
            });
        });
    }

    // Move WAR button in the bottom widget inline with sort dropdown
    const bottomWarButton = document.querySelector(selector+' .okeReviews-reviewsWidget-header-controls .js-okeReviews-writeReview');
    const bottomReviewControl = document.querySelector(selector+' .okeReviews-reviews .okeReviews-reviews-controls-sort');
    if (bottomWarButton && bottomReviewControl) {
        bottomReviewControl.insertAdjacentElement('afterbegin', bottomWarButton);
    }

    // restructure reviews on change
    if(document.querySelector('#collapse-tab-okendo .js-okeReviews-reviews-main') != null) {
      restructureIndividualReviews();
      var okeObserver = new MutationObserver(restructureIndividualReviews);
      okeObserver.observe(document.querySelector('#collapse-tab-okendo .js-okeReviews-reviews-main'), { childList: true });
    }

    //restructure slider review item 
    if(document.querySelector('#reviews .okeReviews-review--carousel') != null) {
      restructureIndividualSliderReviews();
      var okeObserver2 = new MutationObserver(restructureIndividualSliderReviews);
      okeObserver2.observe(document.querySelector('#collapse-tab-okendo .okeReviews-review--carousel .js-okeReviews-reviews-main'), { childList: true });
    }
};

function restructureIndividualReviews() {
    // move collapsable widget stars
    for (const review of document.querySelectorAll('#collapse-tab-okendo .js-okeReviews-review')) {
        const reviewMeta = review.querySelector('.js-okeReviews-reviewMeta');    
        const profileDetails = review.querySelector('.okeReviews-review-reviewer-profile-details');
        if (reviewMeta && profileDetails) {
            profileDetails.append(reviewMeta);
        }
    }
}

function restructureIndividualSliderReviews() {
  
    // move collapsable widget stars
    for (const review of document.querySelectorAll('#reviews .okeReviews-reviewsWidget--carousel .js-okeReviews-review')) {
        const attributes = review.querySelector('.okeReviews-review-reviewer-attributes');    
        const target = review.querySelector('.okeReviews-review-attributeRatings');
        if (attributes && target) {
            target.after(attributes);
        }
    }
}
